// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3hBxO","buttons":"SendReceipts_buttons__2Fxap","email":"SendReceipts_email__34o9G","bookApptTitle":"SendReceipts_bookApptTitle__TP9Yl"};